jQuery = require 'jquery'
banzai = require 'ub/control/banzai-features'
_      = require 'lodash'

module.exports = (saveObs) ->

  unsaved      = false
  unsavedTypes = ['pageSaving', 'pageUnsaved', 'pageSaveFailed']
  message      = "You have unsaved changes. If you leave they will be lost.
                  To save them click 'Stay on this Page', and then click
                  the 'Save' button."

  window.onbeforeunload = ->
    message if unsaved and not banzai.features.isSandboxEnabled()

  saveObs.subscribe (ev) ->
    unsaved = _.contains unsavedTypes, ev.type



// WEBPACK FOOTER //
// ./src/control/check-unsaved-nav.coffee